import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface SupportDto {
  loading?: boolean;
  data: {};
}

export const getSupportData = createAsyncThunk(
  "support/getSupportData",
  async () => {
    const response: any = await axios.get(APIRoutes.SUPPORT);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data?.[0] ?? {} };
  }
);

export const saveSupportData = createAsyncThunk(
  "support/saveSupportData",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.SUPPORT, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const updateSupportData = createAsyncThunk(
  "support/updateSupportData",
  async (data: any) => {
    const response: any = await axios.patch(
      `${APIRoutes.SUPPORT}/${data?.id ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: SupportDto = {
  loading: false,
  data: {},
};

export const support = createSlice({
  name: "support",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupportData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getSupportData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default support.reducer;
